import React, {useContext, useEffect} from "react";
import FeedbackContext from "../../contexts/eventFeedback";
import '../../assets/css/eventFeedback/EventFeedback.css'
import NormalSizeCloseBtn from "../buttons/NormalSizeCloseBtn";
import ErrorBoundary from "../../ErrorBoundary/ErrorBoundary";

const EventFeedback = () => {
    const {currentMessage, resetTimer, getQueueLength, clearAll} = useContext(FeedbackContext);

    const closeEventFeedback = (e) => {
        e.stopPropagation();

        let eventFeedbackWrapper = document.getElementById("eventFeedbackWrapper");
        let eventFeedbackTimerLine = document.getElementById("eventFeedbackTimerLine");

        eventFeedbackWrapper.classList.remove("appearDisappearAnimation");
        eventFeedbackTimerLine.classList.remove("timerTickAnimation");
        eventFeedbackWrapper.style.display = "none";

        resetTimer();
    }

    useEffect(() => {
        if(currentMessage){

            // get els
            let messageFeedback = document.getElementById("messageFeedback");
            let eventFeedbackWrapper = document.getElementById("eventFeedbackWrapper");
            let eventFeedbackTimerLine = document.getElementById("eventFeedbackTimerLine");

            // make visible
            if(messageFeedback && eventFeedbackTimerLine && eventFeedbackWrapper){
                eventFeedbackWrapper.style.display = "block"

                // start animations
                eventFeedbackWrapper.classList.remove("appearDisappearAnimation");
                eventFeedbackTimerLine.classList.remove("timerTickAnimation");

                // resets animation *** NECESSARY *** (for every animation trigger after the first) 
                void eventFeedbackWrapper.offsetWidth;

                // if(currentMessage.type === "error"){
                //     // adds error theme
                //     eventFeedbackContainer.classList.remove("eventFeedbackSuccess");
                //     eventFeedbackContainer.classList.add("eventFeedbackError");
                // }
                // if(currentMessage.type === "success"){
                //     // adds success theme
                //     eventFeedbackContainer.classList.remove("eventFeedbackError");
                //     eventFeedbackContainer.classList.add("eventFeedbackSuccess");
                // }
                
                // adds message contents
                messageFeedback.innerText = currentMessage.message;

                // eventFeedbackWrapper.style.display = "block"

                eventFeedbackWrapper.classList.add("appearDisappearAnimation");
                eventFeedbackTimerLine.classList.add("timerTickAnimation");
            }

        }

        else{
            let eventFeedbackWrapper = document.getElementById("eventFeedbackWrapper");
            if(eventFeedbackWrapper)
                eventFeedbackWrapper.style.display = "none";

        }
    }, [currentMessage])

    return(
        <>
            <ErrorBoundary fallback={"There was an error."}>
                {currentMessage && 
                    <div id="eventFeedbackWrapper" className="eventFeedbackWrapper">
                        <div className="eventFeedbackSticky">
                            <div className={"eventFeedbackClearAll textAlignCenter "+(currentMessage.type === "success" ? "eventFeedbackSuccess" : "eventFeedbackError")} onClick={(e) => {
                                    clearAll();
                                    closeEventFeedback(e);
                            }} >
                                Clear All ({getQueueLength()} Left)
                            </div>
                            <div id="eventFeedbackContainer" className={"eventFeedbackContainer flexAlignCenter "+(currentMessage.type === "success" ? "eventFeedbackSuccess" : "eventFeedbackError")}>
                                <div className="eventFeedbackMessageContainer">
                                    <div id="messageFeedback" className="eventFeedbackMessage">
                                        {currentMessage.message}
                                    </div>
                                </div>
                                <div onClick={closeEventFeedback} className="eventFeedbackCloseButton">
                                    <NormalSizeCloseBtn />
                                </div>
                                <div id="eventFeedbackTimerLine" className="eventFeedbackContainerTimerLine">
                                    {/* leave empty */}
                                </div>
                            </div>
                        </div>
                    </div>  
                }
            </ErrorBoundary>  
        </>
    );
}

export default EventFeedback;